import type { ReactNode } from "react";

import ImperoShare from "@impero-com/common/img/impero-share.svg";
import ControlManagement from "@impero-com/common/img/nav/control-management.svg";
import ControlTesting from "@impero-com/common/img/nav/control-testing.svg";
import Help from "@impero-com/common/img/nav/help.svg";
import Home from "@impero-com/common/img/nav/home.svg";
import Reports from "@impero-com/common/img/nav/reports.svg";
import RiskManagement from "@impero-com/common/img/nav/risk-management.svg";
import Settings from "@impero-com/common/img/nav/settings.svg";
import UserManagement from "@impero-com/common/img/nav/user-management.svg";
import { Svg } from "@impero-com/ui";
import type { NavIconName } from "@impero-com/ui/domain";

export const navIcons = {
    home: Home,
    controlManagement: ControlManagement,
    controlTesting: ControlTesting,
    riskManagement: RiskManagement,
    reports: Reports,
    userManagement: UserManagement,
    settings: Settings,
    help: Help,
} as const;

export const navIconNodes = {
    home: <NavIcon src={Home} />,
    controlManagement: <NavIcon src={ControlManagement} />,
    controlTesting: <NavIcon src={ControlTesting} />,
    imperoShare: <NavIcon src={ImperoShare} />,
    riskManagement: <NavIcon src={RiskManagement} />,
    reports: <NavIcon src={Reports} />,
    userManagement: <NavIcon src={UserManagement} />,
    settings: <NavIcon src={Settings} />,
} satisfies Record<NavIconName, ReactNode>;

interface NavIconProps {
    src?: string;
    className?: string;
}

export function NavIcon({ src, className }: NavIconProps) {
    return src === undefined ? null : <Svg className={className} src={src} />;
}
